import { api } from '@/lib/api'

/**
 * @param {number} saleId
 * @param {{
 *   reason: string,
 *   manager_email: string,
 *   manager_password: string,
 *   refunds?: Array<{ payment_method_id: number, amount: number, reference?: string }>
 * }} payload
 */
export async function refundSale(saleId, payload) {
  const { data } = await api.post(`/sales/${saleId}/refund`, payload)
  return data.data
}

/**
 * @param {number} saleId
 */
export async function fetchSale(saleId) {
  const { data } = await api.get(`/sales/${saleId}`)
  return data.data.sale
}
